import React from "react";
import Helmet from "react-helmet";

/**
 * Safe HTML → plain text
 * - No DOM usage
 * - SSR safe
 * - No dependencies
 */
const stripHtmlSafe = (html) => {
  if (typeof html !== "string") return "";

  let text = html.replace(/<(script|style)[^>]*>[\s\S]*?<\/\1>/gi, "");
  text = text.replace(/<\/?[^>]+(>|$)/g, "");

  text = text
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">");

  return text.replace(/\s+/g, " ").trim();
};

/**
 * FAQ Schema Component
 * - NEVER throws
 * - Skips bad / incomplete data
 * - Emits schema ONLY when valid FAQs exist
 */
const FAQSchema = ({ modules, enabled = true }) => {
  try {
    // Hard stop conditions
    if (!enabled) return null;
    if (!Array.isArray(modules) || modules.length === 0) return null;

    const faqItems = [];

    modules.forEach((module) => {
      if (!module || typeof module !== "object") return;

      /* -------------------------
       * Case 1: Select_FAQs
       * ------------------------- */
      if (Array.isArray(module.Select_FAQs)) {
        module.Select_FAQs.forEach((item) => {
          const question = stripHtmlSafe(item?.Question);
          const answer = stripHtmlSafe(item?.Answer);

          if (question && answer) {
            faqItems.push({ question, answer });
          }
        });
      }

      /* -------------------------
       * Case 2: Accordion FAQs
       * ------------------------- */
      // if (Array.isArray(module.Add_Accordion)) {
      //   module.Add_Accordion.forEach((item) => {
      //     const question = stripHtmlSafe(item?.Accordion_Title);
      //     const answer = stripHtmlSafe(item?.Accordion_Content);

      //     if (question && answer) {
      //       faqItems.push({ question, answer });
      //     }
      //   });
      // }

      /* -------------------------
       * Case 3: FAQ Collection
       * ------------------------- */
      if (
        module.Select_Collection === "FAQs" &&
        Array.isArray(module.faqs)
      ) {
        module.faqs.forEach((item) => {
          const question = stripHtmlSafe(item?.Question);
          const answer = stripHtmlSafe(item?.Answer);

          if (question && answer) {
            faqItems.push({ question, answer });
          }
        });
      }
    });

    // No valid FAQs → no schema
    if (faqItems.length === 0) return null;

    const schema = {
      "@context": "https://schema.org",
      "@type": "FAQs",
      mainEntity: faqItems.map((item) => ({
        "@type": "Question",
        name: item.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.answer
        }
      }))
    };

    return (
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      </Helmet>
    );
  } catch (e) {
    // Absolute safety net — never break rendering
    return null;
  }
};

export default FAQSchema;
